import API_MAP from "../../constants/api";
import axiosClient from "../axiosClient";

class ApiManagerRole {
    getListRoleFunctions = (id, page = 0, perPage = 5, status = "", search) => {
        return axiosClient.get(API_MAP.ROLES.GET_FUNCTIONS_ASSIGNABLE({ id, page, size: perPage, status, search }));
    }
    getListFunctions = (page = 0, perPage = 5, status = "", search) => {
        return axiosClient.get(API_MAP.GET_LIST_FUNCTIONS + '?page=' + page + '&size=' + perPage + "&status=" + status + "&s=" + search);
    }
    addFunction = data => {
        return axiosClient.post(API_MAP.ADD_FUNCTION, data);
    }
    getOneFunction = (id) => {
        return axiosClient.get(API_MAP.GET_ONE_FUNCTION + '/' + id)
    }
    updateFunction = (id, data) => {
        return axiosClient.post(API_MAP.UPDATE_FUNCTION + "/" + id, data)
    }
    deletFunction = (id) => {
        return axiosClient.post(API_MAP.ADD_FUNCTION + '/delete/' + id)
    }
    getListRole = ({ page = 0, size = 5, is_active = "", s = "" }) => {
        return axiosClient.get(API_MAP.GET_LIST_ROLES + '?page=' + page + "&size=" + size + "&is_active=" + is_active + "&s=" + s)
    }
    addRole = (data) => {
        return axiosClient.post(API_MAP.ADD_ROLE, data)
    }
    getFunctionsRole = (id) => {
        return axiosClient.get(API_MAP.ROLES.GET_FUNCTIONS_ROLE(id))
    }
    getRole = (id) => {
        return axiosClient.get(API_MAP.GET_ROLE + '/' + id)
    }
    editRole = (id, data) => {
        return axiosClient.post(API_MAP.EDIT_ROLE + "/" + id, data)
    }
    searchListRoleFunc = (id, s = "", size = 200) => {
        return axiosClient.get(API_MAP.GET_LIST_ROLE_FUNCTIONS + '/' + id + "/functions?size=" + size + "&s=" + s);
    }
    deleteRole = (id) => {
        return axiosClient.post(API_MAP.DELETE_ROLES + '/' + id);
    }
}

const apiManagerRole = new ApiManagerRole();


export default apiManagerRole;